// TicketDetails.js

import { IoIosArrowBack, IoIosArrowDown, IoIosArrowUp, IoIosClose } from "react-icons/io";
import { useState, useRef, useEffect } from "react";
import "./ticketDetails.css";
import { useLocation, useNavigate } from "react-router-dom";
import RequestSentDetailsDS from "../../../DataServices/RequestSentDetailsDS";
import { useCustomContext } from "../../CustomComponents/CustomComponents";
import { insertLog } from "../../Logs/InsertLog";
import { FiChevronDown, FiX, FiFileText, FiAlertCircle, FiMessageSquare, FiPhoneOutgoing, FiPhone, FiVolume, FiVolume2 } from "react-icons/fi";
import { FiPlay, FiPause, FiMicOff, FiArrowRight, FiPhoneIncoming, FiClock } from "react-icons/fi";
import { FaEye } from "react-icons/fa";
import { FiDownload, FiExternalLink } from "react-icons/fi";
import { MdAttachFile, MdDeleteOutline, MdOutlineAnalytics, MdScheduleSend } from "react-icons/md";
import { BsRobot, BsPerson, BsPinAngle, BsPinAngleFill, BsGrid3X3Gap } from "react-icons/bs";
import { RiCustomerService2Fill } from "react-icons/ri";
import { S3Client, GetObjectCommand, ListObjectsV2Command } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { BiSolidPhoneCall } from "react-icons/bi";
import ReactDOM from "react-dom";
import { GoArchive, GoClock, GoDotFill, GoStar, GoTrash } from "react-icons/go";
import { MdCancel } from "react-icons/md";
import { FaAsterisk, FaList } from "react-icons/fa";
import DialModal from "../DialModal";
import { BsSendArrowUp } from "react-icons/bs";
import CallRecordingPlayerModal from "../RecordPlayerModal";
import SendEmail from "../EmailModel/Sendemail";
import { IoMdMail } from "react-icons/io";
import { TbMailShare } from "react-icons/tb";
import * as pdfjsLib from "pdfjs-dist";
import { Pointer } from "lucide-react";

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

const TicketDetails = () => {

    const requestSentDS = new RequestSentDetailsDS();
    const { showAlert, stopHudRotation, hud, showToast } = useCustomContext();
    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];
    const location = useLocation();
    const navigate = useNavigate();


    const queryParams = new URLSearchParams(location.search);
    const requestIDFromURL = queryParams.get("requestID");

    const [record, setRecord] = useState(location.state?.fullData?.requests || {});
    const [agencyPhoneNumber, setAgencyPhoneNumber] = useState(location.state?.fullData?.agencyPhoneNumber || "");
    const [files, setFiles] = useState(location.state?.fullData?.files || null);

    const [openSection, setOpenSection] = useState(["events"]);

    const [callHistory, setCallHistory] = useState([]);

    const [dialOpen, setDialOpen] = useState(false);
    const [dialRequestId, setDialRequestId] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalItem, setModalItem] = useState(null);

    const [audioUrl, setAudioUrl] = useState(null);
    const [playingId, setPlayingId] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const audioRef = useRef(null);
    const [expandedAnalysis, setExpandedAnalysis] = useState(null);


    const [textArea, setTextArea] = useState("");
    const [showAddModal, setShowAddModal] = useState(false);
    const [eventData, setEventData] = useState({ startDateTime: "", endDateTime: "", message: "" });
    const [showEventModal, setShowEventModal] = useState(false);
    const [eventErrors, setEventErrors] = useState({});
    const [chequeErrors, setChequeErrors] = useState({});
    const [notesError, setNotesError] = useState({})

    const [isPinned, setIsPinned] = useState(false);

    const [toEmails, setToEmails] = useState([]);

    const [showMailModal, setShowMailModal] = useState(false);
    const [mailHistory, setMailHistory] = useState([]);
    const [selectedMail, setSelectedMail] = useState(null);
    const [showMailHeaderDetails, setShowMailHeaderDetails] = useState(false);
    const [mailAttachments, setMailAttachments] = useState([]);
    const [, setLoadingMailAttachments] = useState(false);
    const [pdfThumbnails, setPdfThumbnails] = useState({});
    const mailHeaderToggleRef = useRef(null);
    const mailHeaderDetailsRef = useRef(null);

    const [callAndMailSettings, setCallAndMailSettings] = useState(location.state?.fullData?.callAndMailSettings?.waitDaysBeforeSendingAnotherEmail || 0);

    const [viewMode, setViewMode] = useState("grid");

    const [showChequeModal, setShowChequeModal] = useState(false);
    const [showViewChequeModal, setShowViewChequeModal] = useState(false);
    const [chequePdfUrl, setChequePdfUrl] = useState("");
    const [chequePaymentTo, setChequePaymentTo] = useState("");
    const [chequeAmount, setChequeAmount] = useState("");
    const [chequeMemo, setChequeMemo] = useState("");
    const [chequeAddress, setChequeAddress] = useState({ address: "", city: "", state: "", zip: "" });
    const [viewChequeRequestId, setViewChequeRequestId] = useState("");
    const [chequeData, setChequeData] = useState(null);

    const [openEmailDropdown, setOpenEmailDropdown] = useState(null);

    const toggleEmailDropdown = (type) => {
        setOpenEmailDropdown(prev =>
            prev === type ? null : type
        );
    };

    const requestDropdownRef = useRef(null);
    const responseDropdownRef = useRef(null);
    useEffect(() => {

        const handleClickOutside = (event) => {

            if (
                requestDropdownRef.current &&
                !requestDropdownRef.current.contains(event.target)
            ) {
                setOpenEmailDropdown((prev) =>
                    prev === "request" ? null : prev
                );
            }

            if (
                responseDropdownRef.current &&
                !responseDropdownRef.current.contains(event.target)
            ) {
                setOpenEmailDropdown((prev) =>
                    prev === "response" ? null : prev
                );
            }

        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);

    useEffect(() => {
        if (!requestIDFromURL) return;
        // if (location.state?.fullData?.requests) return;
        fetchRecord();
    }, [requestIDFromURL]);

    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;

        const onLoaded = () => setDuration(audio.duration);
        const onTimeUpdate = () => setCurrentTime(audio.currentTime);
        const onEnded = () => setIsPlaying(false);

        audio.addEventListener("loadedmetadata", onLoaded);
        audio.addEventListener("timeupdate", onTimeUpdate);
        audio.addEventListener("ended", onEnded);

        return () => {
            audio.removeEventListener("loadedmetadata", onLoaded);
            audio.removeEventListener("timeupdate", onTimeUpdate);
            audio.removeEventListener("ended", onEnded);
        };
    }, [audioUrl]);


    useEffect(() => {

        if (!record) return;

        const requestType = record?.requestMethod?.requestType;
        const emailSettings = record?.requestMethod?.emailSettings || [];
        if (requestType === "Email" && Array.isArray(emailSettings)) {
            setToEmails(emailSettings);
        } else {
            setToEmails([]);
        }

    }, [record]);

    const fetchRecord = async () => {
        hud("Please Wait...");
        try {
            const response = await requestSentDS.WS_OutgoingRequest_Details_GET({
                requestID: requestIDFromURL
            });
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && body) {
                setRecord(body.requests || {});
                setAgencyPhoneNumber(body.agencyPhoneNumber || "");
                setFiles(body.files || null);
                setCallAndMailSettings(body.callAndMailSettings?.waitDaysBeforeSendingAnotherEmail || 0);

                console.log("Requests", body.requests);
                console.log("Files", body.files);
                console.log("waitDays", body.callAndMailSettings?.waitDaysBeforeSendingAnotherEmail || 0);
                insertLog(
                    `${userName} viewed ticket details for VIN '${requestIDFromURL}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    requestIDFromURL || '',
                    'GET',
                    'WS_OutgoingRequest_Details_GET',
                    'SUCCESS',
                    ''
                );
            } else {
                showAlert(body.message || "Failed to load record.", [
                    { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
                ]);
                insertLog(
                    `${userName} failed to load ticket details for VIN '${requestIDFromURL}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    requestIDFromURL || '',
                    'GET',
                    'WS_OutgoingRequest_Details_GET',
                    'FAILED',
                    'Unable to load ticket details'
                );
            }
        } catch (err) {
            showAlert(err.message || "Error loading record.", [
                { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
            ]);
            insertLog(
                `${userName} failed to load ticket details for VIN '${requestIDFromURL}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                requestIDFromURL || '',
                'GET',
                'WS_OutgoingRequest_Details_GET',
                'FAILED',
                'Error occurred while loading ticket details'
            );
        } finally {
            stopHudRotation();
        }
    };


    // const handleViewPDF = async (id) => {
    //     try {
    //         hud("Please Wait..");
    //         const response = await requestSentDS.WS_SentPdfData_ByID_GET({ _id: id });
    //         const data = response.data;
    //         const base64String = data.body;
    //         if (data.statusCode === 200 && base64String) {
    //             const byteCharacters = atob(base64String);
    //             const byteNumbers = new Array(byteCharacters.length);
    //             for (let i = 0; i < byteCharacters.length; i++) {
    //                 byteNumbers[i] = byteCharacters.charCodeAt(i);
    //             }
    //             const byteArray = new Uint8Array(byteNumbers);
    //             const blob = new Blob([byteArray], { type: "application/pdf" });
    //             const blobUrl = URL.createObjectURL(blob);
    //             window.open(blobUrl, "_blank");

    //             insertLog(
    //                 `${userName} viewed PDF for VIN '${record.requestID}' and agency '${record.agencyName}'`,
    //                 0,
    //                 useremail,
    //                 hud,
    //                 stopHudRotation,
    //                 showAlert,
    //                 record.requestID || '',
    //                 'GET',
    //                 'WS_SentPdfData_ByID_GET',
    //                 'SUCCESS',
    //                 ''
    //             );

    //         }
    //         else {
    //             const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
    //             showAlert(body?.message || "Failed to view pdf.", [
    //                 { label: "Ok", onClick: () => { }, color: 'var(--buttonColor)' }
    //             ]);
    //             insertLog(
    //                 `${userName} failed to view PDF for VIN '${record.requestID}' and agency '${record.agencyName}'`,
    //                 0,
    //                 useremail,
    //                 hud,
    //                 stopHudRotation,
    //                 showAlert,
    //                 record.requestID || '',
    //                 'GET',
    //                 'WS_SentPdfData_ByID_GET',
    //                 'FAILED',
    //                 'Unable to view PDF'
    //             );
    //         }
    //     } catch (err) {
    //         insertLog(
    //             `${userName} failed to view PDF for VIN '${record.requestID}' and agency '${record.agencyName}'`,
    //             0,
    //             useremail,
    //             hud,
    //             stopHudRotation,
    //             showAlert,
    //             record.id || '',
    //             'GET',
    //             'WS_SentPdfData_ByID_GET',
    //             'FAILED',
    //             err.message
    //         );
    //         showAlert(err.message || "Error loading PDF.", [
    //             { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
    //         ]);
    //     } finally {
    //         stopHudRotation();
    //     }
    // };

    const handleViewPDF = async (s3Key) => {
        if (!s3Key) return;
        try {
            hud("Generating preview...");

            const idToken = localStorage.getItem("idToken");

            const bucketName = `${normalizeBucketNamePart(record.datasetID)}-${normalizeBucketNamePart(record.datasetName)}-files-${process.env.REACT_APP_ALIAS}`;

            const s3 = new S3Client({
                region: process.env.REACT_APP_AWS_REGION,
                credentials: fromCognitoIdentityPool({
                    clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                    identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                    logins: {
                        [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
                            idToken,
                    },
                }),
            });

            const { getSignedUrl } = await import("@aws-sdk/s3-request-presigner");
            const { GetObjectCommand } = await import("@aws-sdk/client-s3");

            const command = new GetObjectCommand({
                Bucket: bucketName,
                Key: s3Key,
                ResponseContentDisposition: "inline",
                ResponseContentType: "application/pdf",
            });

            const signedUrl = await getSignedUrl(s3, command, { expiresIn: 300 }); // 5 min
            window.open(signedUrl, "_blank");

        } catch (err) {
            console.error("Presigned URL error:", err);
            showAlert("Failed to generate preview. Please try again.", [
                { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
            ]);

        } finally {
            stopHudRotation();
        }
    };


    const toggleSection = (s) => {
        setOpenSection(prev =>
            prev.includes(s) ? prev.filter(x => x !== s) : [...prev, s]
        );
    };


    const refreshPage = () => {
        window.location.reload();
    }

    const notes = record.notes || [];
    const viewHighlightFileds = ["Sent", "Escalated", "Closed-Data Received", "Closed-No Data", "Payment Pending", "Payment Closed"];
    const emailDatasetID = record.datasetID || location.state?.ticketHistoryState?.datasetID || "";
    const emailDatasetName = record.datasetName || record.dataSetName || location.state?.ticketHistoryState?.datasetName || "";


    const formatToLocalDateTime = (timestamp) => {
        if (!timestamp) return "";

        const normalized = typeof timestamp === "string"
            ? timestamp.trim().replace(" ", "T")
            : timestamp;

        const date = new Date(normalized);
        if (isNaN(date.getTime())) return "";

        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
    };


    const normalizeReqKey = (type) => {
        if (!type) return "";
        type = type.toLowerCase().trim();
        if (type === "fax") return "fax";
        if (type === "email") return "emailReq";
        if (type === "snail mail") return "snail";
        if (type === "drop off") return "dropoff";
        if (type.includes("agency website")) return "agenweb";
        if (type.includes("crash")) return "crashdocx";
        return "";
    };

    const normalizeResKey = (type) => {
        if (!type) return "";
        type = type.toLowerCase().trim();
        if (type.includes("fax")) return "fax";
        if (type.includes("email")) return "email";
        if (type.includes("pick")) return "pickup";
        if (type.includes("snail")) return "snailmail";
        if (type.includes("agency website")) return "agenweb";
        if (type.includes("crash")) return "crashdocs";
        return "";
    };

    const reqMethodKey = normalizeReqKey(record.requestMethod?.requestType);
    const resMethodKey = normalizeResKey(record.responseMethod?.responseType);

    const renderRequestMethodDetails = () => {
        const rm = record.requestMethod || {};
        switch (reqMethodKey) {
            case "fax":
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Fax Numbers</label>
                        {(rm.faxSettings || []).map((fax, i) => (
                            <input key={i} readOnly value={fax} style={{ marginTop: 5 }} />
                        ))}
                    </>
                );
            case "emailReq":
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email Addresses</label>
                        {(rm.emailSettings || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                    </>
                );
            case "snail": {
                const snail = rm.snailMailSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Snail Mail Emails</label>
                        {(snail.emailaddress || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                        <label style={{ marginTop: 8, display: "block" }}>Name</label>
                        <input readOnly value={snail.address?.name || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Address</label>
                        <input readOnly value={snail.address?.address || ""} />
                        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                            <div style={{ flex: 1 }}><label>City</label><input readOnly value={snail.address?.city || ""} /></div>
                            <div style={{ flex: 1 }}><label>State</label><input readOnly value={snail.address?.state || ""} /></div>
                            <div style={{ flex: 1 }}><label>Zip</label><input readOnly value={snail.address?.zip || ""} /></div>
                        </div>
                    </>
                );
            }
            case "dropoff": {
                const drop = rm.dropoffSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Drop Off Emails</label>
                        {(drop.emailaddress || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                        <label style={{ marginTop: 8, display: "block" }}>Name</label>
                        <input readOnly value={drop.address?.name || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Address</label>
                        <input readOnly value={drop.address?.address || ""} />
                        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                            <div style={{ flex: 1 }}><label>City</label><input readOnly value={drop.address?.city || ""} /></div>
                            <div style={{ flex: 1 }}><label>State</label><input readOnly value={drop.address?.state || ""} /></div>
                            <div style={{ flex: 1 }}><label>Zip</label><input readOnly value={drop.address?.zip || ""} /></div>
                        </div>
                    </>
                );
            }
            case "agenweb": {
                const agen = rm.agencyWebsiteSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email</label>
                        <input readOnly value={agen.email || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Website URL</label>
                        <input readOnly value={agen.websiteURL || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Description</label>
                        <input readOnly value={agen.description || ""} />
                    </>
                );
            }
            case "crashdocx": {
                const crash = rm.crashDocsWebsiteSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email</label>
                        <input readOnly value={crash.email || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Website URL</label>
                        <input readOnly value={crash.websiteURL || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Description</label>
                        <input readOnly value={crash.description || ""} />
                    </>
                );
            }
            default: return null;
        }
    };

    const renderResponseMethodDetails = () => {
        const res = record.responseMethod || {};
        switch (resMethodKey) {
            case "fax":
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Fax Numbers</label>
                        {(res.faxSettings || []).map((fax, i) => (
                            <input key={i} readOnly value={fax} style={{ marginTop: 5 }} />
                        ))}
                    </>
                );
            case "email":
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email Addresses</label>
                        {(res.emailSettings || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                    </>
                );
            case "snailmail": {
                const snail = res.snailMailSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Snail Mail Emails</label>
                        {(snail.emailaddress || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                        <label style={{ marginTop: 8, display: "block" }}>Name</label>
                        <input readOnly value={snail.address?.name || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Address</label>
                        <input readOnly value={snail.address?.address || ""} />
                        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                            <div style={{ flex: 1 }}><label>City</label><input readOnly value={snail.address?.city || ""} /></div>
                            <div style={{ flex: 1 }}><label>State</label><input readOnly value={snail.address?.state || ""} /></div>
                            <div style={{ flex: 1 }}><label>Zip</label><input readOnly value={snail.address?.zip || ""} /></div>
                        </div>
                    </>
                );
            }
            case "pickup": {
                const pickup = res.pickupSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Pick Up Emails</label>
                        {(pickup.emailaddress || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                        <label style={{ marginTop: 8, display: "block" }}>Name</label>
                        <input readOnly value={pickup.address?.name || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Address</label>
                        <input readOnly value={pickup.address?.address || ""} />
                        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                            <div style={{ flex: 1 }}><label>City</label><input readOnly value={pickup.address?.city || ""} /></div>
                            <div style={{ flex: 1 }}><label>State</label><input readOnly value={pickup.address?.state || ""} /></div>
                            <div style={{ flex: 1 }}><label>Zip</label><input readOnly value={pickup.address?.zip || ""} /></div>
                        </div>
                    </>
                );
            }
            case "agenweb": {
                const agen = res.agencyWebsiteSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email</label>
                        <input readOnly value={agen.email || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Website URL</label>
                        <input readOnly value={agen.websiteURL || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Description</label>
                        <input readOnly value={agen.description || ""} />
                    </>
                );
            }
            case "crashdocs": {
                const crash = res.crashDocsWebsiteSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email</label>
                        <input readOnly value={crash.email || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Website URL</label>
                        <input readOnly value={crash.websiteURL || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Description</label>
                        <input readOnly value={crash.description || ""} />
                    </>
                );
            }
            default: return null;
        }
    };


    const handleTextSubmit = async (e) => {
        e.preventDefault();


        const newErrors = {};

        if (!textArea?.trim()) {
            newErrors.text = "Notes are required";
        }

        setNotesError(newErrors);

        if (Object.keys(newErrors).length > 0) {
            return;
        }


        hud("Please Wait..");

        try {

            const req =
            {
                _id: record._id,
                text: textArea.trim(),
                updated_by_email_id: useremail,
                isPinned: isPinned
            };

            const response = await requestSentDS.WS_OutgoingRequest_Notes_ByID_UPDATE(req);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200 && body.message === "Note added successfully") {
                showToast({ message: "Notes added successfully" });

                await fetchRecord();

                insertLog(
                    `${userName} added a note for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Notes_ByID_UPDATE',
                    'SUCCESS',
                    ''
                );
                // await refreshRecord();
            } else {
                showAlert(body?.message || "Unable to add note.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
                insertLog(
                    `${userName} failed to add a note for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Notes_ByID_UPDATE',
                    'FAILED',
                    'Unable to add note'
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to add a note for '${record.requestID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.id || '',
                'UPDATE',
                'WS_OutgoingRequest_Notes_ByID_UPDATE',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Failed.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
        } finally { stopHudRotation(); setShowAddModal(false); }
    };

    const handlePinNote = async (noteIndex, currentPinState) => {
        try {

            hud("Please Wait..");

            const req = {
                _id: record._id,
                noteIndex: noteIndex,
                isPinned: !currentPinState,
                updated_by_email_id: useremail
            };

            const response =
                await requestSentDS.WS_OutgoingRequest_Notes_ByID_UPDATE(req);

            const data = response.data;
            const body =
                typeof data.body === "string"
                    ? JSON.parse(data.body)
                    : data.body;

            if (data.statusCode === 200) {

                showToast({
                    message: currentPinState
                        ? "Note unpinned"
                        : "Note pinned"
                });
                insertLog(
                    `${userName} ${currentPinState ? 'unpinned' : 'pinned'} a note for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.requestID || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Notes_ByID_UPDATE',
                    'SUCCESS',
                    ''
                );

                await fetchRecord();

            } else {

                showAlert(
                    body?.message || "Failed to update pin.",
                    [
                        {
                            label: "OK",
                            onClick: () => { },
                            color: "var(--buttonColor)"
                        }
                    ]
                );
                insertLog(
                    `${userName} failed to update note pin status for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.requestID || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Notes_ByID_UPDATE',
                    'FAILED',
                    'Unable to update note pin status'
                );
            }

        } catch (err) {

            showAlert(
                err.message || "Failed.",
                [
                    {
                        label: "OK",
                        onClick: () => { },
                        color: "var(--buttonColor)"
                    }
                ]
            );
            insertLog(
                `${userName} failed to update note pin status for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.requestID || '',
                'UPDATE',
                'WS_OutgoingRequest_Notes_ByID_UPDATE',
                'FAILED',
                'Error occurred while updating note pin status'
            );

        } finally {

            stopHudRotation();
        }
    };


    const handleEventSubmit = async (e) => {
        e.preventDefault();
        const errs = {};
        if (!eventData.startDateTime) errs.startDateTime = "Start Date Time is required";
        if (!eventData.endDateTime) errs.endDateTime = "End Date Time is required";
        if (!eventData.message) errs.message = "Message is required";



        setEventErrors(errs);

        if (Object.keys(errs).length > 0) return;

        hud("Please Wait..");
        try {
            const req = {
                _id: record._id,
                startDateTime: eventData.startDateTime.replace("T", " ") + ":00",
                endDateTime: eventData.endDateTime.replace("T", " ") + ":00",
                message: eventData.message,
                updated_by_email_id: useremail

            };
            const response = await requestSentDS.WS_OutgoingRequest_Event_ByID_UPDATE(req);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200) {
                await fetchRecord();

                insertLog(
                    `${userName} added an event for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Event_ByID_UPDATE',
                    'SUCCESS',
                    ''
                );
                showToast({ message: "Event added successfully" });
                // await refreshRecord();
            } else {
                showAlert(body?.message || "Unable to add event.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
                insertLog(
                    `${userName} failed to add an event for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Event_ByID_UPDATE',
                    'FAILED',
                    'Unable to add event'
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to add an event for '${record.requestID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.id || '',
                'UPDATE',
                'WS_OutgoingRequest_Event_ByID_UPDATE',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Failed.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
        } finally {
            stopHudRotation();
            setShowEventModal(false);
            setEventErrors({});
        }
    };

    const handlePlay = async (key, id) => {
        try {

            // SAME AUDIO CLICKED
            if (playingId === id && audioRef.current) {

                if (isPlaying) {

                    audioRef.current.pause();
                    setIsPlaying(false);

                } else {

                    await audioRef.current.play();
                    setIsPlaying(true);
                }

                return;
            }

            // STOP OLD AUDIO
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }

            // GET NEW URL
            const url = await getAudioUrl(key);

            // SET STATES
            setAudioUrl(url);
            setPlayingId(id);
            setCurrentTime(0);

            // SET AUDIO SOURCE MANUALLY
            if (audioRef.current) {

                audioRef.current.src = url;

                await audioRef.current.play();

                setIsPlaying(true);
            }

        } catch (err) {

            console.error("Error playing audio:", err);
        }
    };


    const handleOpenCallforAction = () => {
        if (agencyPhoneNumber) {
            setDialRequestId(record.requestID);
            insertLog(
                `${userName} initiated Call for Action for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.requestID || '',
                'ADD',
                'CALL_FOR_ACTION',
                'SUCCESS',
                ''
            );
            setDialOpen(true);
        }
        else {
            showAlert(
                "Agency phone number is not available for calling.",
                [
                    {
                        label: "Ok",
                        onClick: () => { },
                        color: "var(--buttonColor)"
                    }
                ]
            );
        }
    }

    const closeAnalysisModal = () => {

        // stop audio
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current.src = "";
        }

        // reset states
        setIsPlaying(false);
        setPlayingId(null);
        setAudioUrl("");

        // close modal
        setExpandedAnalysis(null);
    };

    const handleHistoryToggle = async () => {
        if (openSection.includes("history")) {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }

            setAudioUrl(null);
            setPlayingId(null);
            setIsPlaying(false);
            setCurrentTime(0);
            setDuration(0);

            setCallHistory([]);

            toggleSection("history");
            setExpandedAnalysis(null);

        } else {
            toggleSection("history");
            setExpandedAnalysis(null);

            await fetchCallHistory(record.requestID);
        }
    };

    const formatTime = (time) => {
        if (!time) return "00:00";

        const total = Math.floor(time); // 🔥 important
        const minutes = Math.floor(total / 60);
        const seconds = (total % 60).toString().padStart(2, "0");

        return `${minutes}:${seconds}`;
    };


    const getAudioUrl = async (key) => {
        const idToken = localStorage.getItem("idToken");

        const s3 = new S3Client({
            region: process.env.REACT_APP_AWS_REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                logins: {
                    [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]: idToken,
                },
            }),
        });

        const command = new GetObjectCommand({
            Bucket: process.env.REACT_APP_CONNECT_BUCKET,
            Key: key,
        });

        const url = await getSignedUrl(s3, command, { expiresIn: 3600 });
        return url;
    };
    const getAuthenticatedS3Client = () => {
        const idToken = localStorage.getItem("idToken");
        return new S3Client({
            region: process.env.REACT_APP_AWS_REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                logins: {
                    [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]: idToken,
                },
            }),
        });
    };

    const normalizeBucketNamePart = (value) => (
        String(value || "")
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "-")
            .replace(/-+/g, "-")
            .replace(/^-+|-+$/g, "")
    );

    const getMailAttachmentBucketName = (mailItem = {}) => {
        const datasetIdPart = normalizeBucketNamePart(emailDatasetID || mailItem.datasetID || mailItem.dataSetId);
        const datasetNamePart = normalizeBucketNamePart(emailDatasetName || mailItem.datasetName || mailItem.dataSetName);
        const aliasPart = normalizeBucketNamePart(process.env.REACT_APP_ALIAS);

        if (datasetIdPart && datasetNamePart && aliasPart) {
            return `${datasetIdPart}-${datasetNamePart}-files-${aliasPart}`;
        }

        return "";
    };

    const resolveAttachmentKeys = async (mailItem, s3) => {
        if (!mailItem?.hasAttachment || !mailItem?.s3Key) return [];

        const bucketName = getMailAttachmentBucketName(mailItem);
        const rootKey = String(mailItem.s3Key).trim();
        if (!bucketName) return [];
        if (!rootKey) return [];

        if (rootKey.includes(".") && !rootKey.endsWith("/")) return [rootKey];

        const prefix = rootKey.endsWith("/") ? rootKey : `${rootKey}/`;
        const listCommand = new ListObjectsV2Command({
            Bucket: bucketName,
            Prefix: prefix
        });
        const listResponse = await s3.send(listCommand);

        const keys = (listResponse.Contents || [])
            .map((obj) => obj.Key)
            .filter((key) => key && !key.endsWith("/"));

        if (keys.length > 0) return keys;
        return [rootKey];
    };

    const loadMailAttachments = async (mailItem) => {
        if (!mailItem?.hasAttachment || !mailItem?.s3Key) {
            return { ok: true, attachments: [] };
        }

        try {
            const s3 = getAuthenticatedS3Client();
            const bucketName = getMailAttachmentBucketName(mailItem);
            if (!bucketName) return { ok: false, attachments: [] };

            const objectKeys = await resolveAttachmentKeys(mailItem, s3);

            if (objectKeys.length === 0) return { ok: true, attachments: [] };

            const attachments = await Promise.all(
                objectKeys.map(async (key) => {
                    const command = new GetObjectCommand({ Bucket: bucketName, Key: key });
                    const url = await getSignedUrl(s3, command, { expiresIn: 3600 });
                    return {
                        key,
                        name: key.split("/").pop() || "attachment",
                        url
                    };
                })
            );

            return { ok: true, attachments };
        } catch (err) {
            return { ok: false, attachments: [] };
        }
    };


    const shouldShowCallAction = (record) => {

        if (!record) return false;

        if (record.totalFilesCount  > 0) {
            return false;
        }

        if (record.url) return false;

        if (!record.TriggerEvents || record.TriggerEvents.length === 0) return true;

        const waitDays = Number(record.TriggerEvents[0]?.waitDays ?? 0);

        if (!record.triggeredOnDate) return false;

        const [year, month, day] = record.triggeredOnDate
            .split("-")
            .map(Number);

        const triggeredHour = Number(record.triggeredAtHour ?? 0);

        // Trigger time in ET
        const triggerET = new Date(
            `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}T${String(triggeredHour).padStart(2, "0")}:00:00`
        );

        const threshold = new Date(triggerET);
        threshold.setDate(threshold.getDate() + waitDays);

        const nowET = new Date(
            new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
        );

        return nowET >= threshold;

    };

    const fetchCallHistory = async (requestID) => {
        try {
            hud("Please Wait..");
            const req = { vin_id: requestID };
            const response = await requestSentDS.AC_Call_Info_By_VIN_GET(req);
            const data = response.data;
            const body = Array.isArray(data.body)
                ? data.body
                : typeof data.body === "string"
                    ? JSON.parse(data.body)
                    : data.body;

            if (data.statusCode === 200 && Array.isArray(body)) {
                setCallHistory(body);

                console.log("callDATA", setCallHistory(body));
                insertLog(
                    `${userName} viewed call history for VIN '${requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    requestID || '',
                    'GET',
                    'AC_Call_Info_By_VIN_GET',
                    'SUCCESS',
                    ''
                );
            } else {
                showAlert(body?.message || "Failed to load call history.", [
                    { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
                ]);
                insertLog(
                    `${userName} failed to load call history for VIN '${requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    requestID || '',
                    'GET',
                    'AC_Call_Info_By_VIN_GET',
                    'FAILED',
                    'Unable to load call history'
                );
            }
        } catch (err) {
            showAlert(err.message || "Something went wrong while fetching call history.", [
                { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
            ]);
            insertLog(
                `${userName} failed to load call history for VIN '${requestID}' and agency '${record.agencyName}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                requestID || '',
                'GET',
                'AC_Call_Info_By_VIN_GET',
                'FAILED',
                'Error occurred while loading call history'
            );
        } finally {
            stopHudRotation();
        }
    };


    const handleOpenMail = () => {

        insertLog(
            `${userName} initiated Send Email for VIN '${record.requestID}' and agency '${record.agencyName}'`,
            0,
            useremail,
            hud,
            stopHudRotation,
            showAlert,
            record.requestID || '',
            'ADD',
            'SEND_EMAIL',
            'SUCCESS',
            ''
        );

        setShowMailModal(true);
    }

    const handleMailHistory = async () => {

        if (openSection.includes("mail")) {
            toggleSection("mail");
        } else {
            toggleSection("mail");
            await fetchMailHistory();
        }
    };

    const fetchMailHistory = async () => {

        hud("Please Wait...");

        try {

            const response =
                await requestSentDS.AC_Mail_Info_By_VIN_GET({
                    vin_id: record.requestID
                });

            const data = response.data;

            const body =
                typeof data.body === "string"
                    ? JSON.parse(data.body)
                    : data.body;

            if (data.statusCode === 200 && body) {
                const baseRows = Array.isArray(body) ? body : [];
                const s3 = getAuthenticatedS3Client();
                const rowsWithAttachmentNames = await Promise.all(
                    baseRows.map(async (mail) => {
                        if (!mail?.hasAttachment || !mail?.s3Key) {
                            return { ...mail, attachmentNames: [] };
                        }
                        try {
                            const keys = await resolveAttachmentKeys(mail, s3);
                            const names = keys
                                .map((key) => key.split("/").pop() || "")
                                .filter(Boolean);
                            return { ...mail, attachmentNames: names };
                        } catch {
                            return { ...mail, attachmentNames: [] };
                        }
                    })
                );

                setMailHistory(rowsWithAttachmentNames);

                console.log("Mail History", body);
                insertLog(
                    `${userName} viewed mail history for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.requestID || '',
                    'GET',
                    'AC_Mail_Info_By_VIN_GET',
                    'SUCCESS',
                    ''
                );

            } else {

                showAlert(
                    body.message || "Failed to load mail history.",
                    [
                        {
                            label: "OK",
                            onClick: () => { },
                            color: "var(--buttonColor)"
                        }
                    ]
                );
                insertLog(
                    `${userName} failed to load mail history for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.requestID || '',
                    'GET',
                    'AC_Mail_Info_By_VIN_GET',
                    'FAILED',
                    'Unable to load mail history'
                );
            }

        } catch (err) {

            showAlert(
                err.message || "Error loading mail history.",
                [
                    {
                        label: "OK",
                        onClick: () => { },
                        color: "var(--buttonColor)"
                    }
                ]
            );
            insertLog(
                `${userName} failed to load mail history for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.requestID || '',
                'GET',
                'AC_Mail_Info_By_VIN_GET',
                'FAILED',
                'Error occurred while loading mail history'
            );

        } finally {

            stopHudRotation();
        }
    };

    const parseIfJsonString = (value) => {
        if (typeof value !== "string") return value;
        try {
            return JSON.parse(value);
        } catch {
            return value;
        }
    };

    const getMailContent = (item) => {
        if (!item) return { body: "", isHtml: false };

        const bodyCandidates = [
            item.message,
            item.body,
            item.content,
            item.mailBody,
            item.html,
            item.htmlBody,
            item.textBody,
            item.emailBody
        ];

        for (const value of bodyCandidates) {
            if (typeof value === "string" && value.trim() !== "") {
                const trimmed = value.trim();
                const isHtml = /<\/?[a-z][\s\S]*>/i.test(trimmed);
                return { body: trimmed, isHtml };
            }
        }

        const nestedCandidates = [
            parseIfJsonString(item.payload),
            parseIfJsonString(item.response),
            parseIfJsonString(item.data),
            parseIfJsonString(item.raw),
            parseIfJsonString(item.mailData),
            parseIfJsonString(item.body)
        ].filter(Boolean);

        for (const nested of nestedCandidates) {
            if (typeof nested !== "object") continue;
            const textValue =
                nested.message ||
                nested.text ||
                nested.body ||
                nested.content ||
                nested.mailBody ||
                nested.textBody;
            const htmlValue = nested.html || nested.htmlBody;

            if (typeof htmlValue === "string" && htmlValue.trim() !== "") {
                return { body: htmlValue.trim(), isHtml: true };
            }

            if (typeof textValue === "string" && textValue.trim() !== "") {
                const trimmed = textValue.trim();
                const isHtml = /<\/?[a-z][\s\S]*>/i.test(trimmed);
                return { body: trimmed, isHtml };
            }
        }

        return { body: "", isHtml: false };
    };

    const getMailSnippet = (item) => {
        const { body, isHtml } = getMailContent(item);
        if (!body) return "";

        const text = isHtml ? body.replace(/<[^>]+>/g, " ") : body;
        return text.replace(/\s+/g, " ").trim();
    };

    const getMailToLabel = (mailItem) => {
        const recipients = Array.isArray(mailItem?.recipients) ? mailItem.recipients : [];
        if (recipients.length === 0) return "No Recipient";

        const names = recipients
            .map((email) => {
                const value = String(email || "").trim();
                if (!value) return "";
                return value.includes("@") ? value.split("@")[0] : value;
            })
            .filter(Boolean);

        if (names.length === 0) return "No Recipient";
        if (names.length === 1) return names[0];
        return `${names[0]}, ${names[1]} ...`;
    };

    const getAttachmentLabel = (name) => {
        if (!name) return "Attachment";
        return name;
    };

    const getAttachmentTypeLabel = (name) => {
        if (!name || !name.includes(".")) return "FILE";
        const ext = name.split(".").pop()?.trim().toUpperCase();
        if (!ext) return "FILE";
        return ext.length > 5 ? ext.slice(0, 5) : ext;
    };

    const isImageAttachment = (name) => {
        const ext = (name?.split(".").pop() || "").toLowerCase();
        return ["png", "jpg", "jpeg", "gif", "webp", "bmp"].includes(ext);
    };

    const isPdfAttachment = (name) => {
        const ext = (name?.split(".").pop() || "").toLowerCase();
        return ext === "pdf";
    };

    const isTextPreviewAttachment = (name) => {
        const ext = (name?.split(".").pop() || "").toLowerCase();
        return ["txt", "csv", "json", "xml", "log"].includes(ext);
    };

    const createPdfThumbnail = async (url) => {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error("Unable to fetch PDF preview");
        }

        const pdfBytes = await response.arrayBuffer();
        const loadingTask = pdfjsLib.getDocument({ data: pdfBytes });
        const pdfDoc = await loadingTask.promise;
        const page = await pdfDoc.getPage(1);

        const viewport = page.getViewport({ scale: 1 });
        const targetWidth = 220;
        const scale = targetWidth / viewport.width;
        const scaledViewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = scaledViewport.width;
        canvas.height = scaledViewport.height;

        await page.render({
            canvasContext: context,
            viewport: scaledViewport
        }).promise;

        return canvas.toDataURL("image/jpeg", 0.9);
    };

    const formatMailDateTime = (value) => {
        if (!value) return "NA";
        const date = new Date(value);
        if (isNaN(date.getTime())) return "NA";
        return date.toLocaleString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        });
    };

    const getSenderDisplayName = (mailItem) => {
        const from = mailItem?.from || "";
        const local = from.includes("@") ? from.split("@")[0] : from;
        if (!local) return "Unknown Sender";
        return local
            .split(/[._-]/g)
            .filter(Boolean)
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join(" ");
    };

    const getSenderInitial = (mailItem) => getSenderDisplayName(mailItem).charAt(0)?.toUpperCase() || "M";

    const handleAttachmentClick = async (e, mailItem, fileName, fileIndex) => {
        e.stopPropagation();

        hud("Opening attachment...");
        try {
            const result = await loadMailAttachments(mailItem);
            if (!result.ok || !result.attachments?.length) {
                showAlert("Unable to open attachment.", [
                    { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
                ]);
                return;
            }

            const byName = result.attachments.find((att) => att.name === fileName);
            const chosen = byName || result.attachments[fileIndex] || result.attachments[0];

            if (!chosen?.url) {
                showAlert("Attachment URL is not available.", [
                    { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
                ]);
                return;
            }

            window.open(chosen.url, "_blank", "noopener,noreferrer");
        } finally {
            stopHudRotation();
        }
    };

    const handleDirectDownload = async (e, url, name) => {
        e.preventDefault();
        e.stopPropagation();
        hud("Downloading attachment...");
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Download failed");

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = name || "attachment";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            showAlert("Unable to download attachment.", [
                { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
            ]);
        } finally {
            stopHudRotation();
        }
    };

    const handleOpenMailDetails = async (item) => {
        if (!item) return;

        hud("Loading mail...");
        setLoadingMailAttachments(true);
        setMailAttachments([]);

        try {
            const result = await loadMailAttachments(item);
            if (item.hasAttachment && !result.ok) {
                showAlert("Unable to load attachments for this email.", [
                    { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
                ]);
                return;
            }

            setMailAttachments(result.attachments || []);
            setPdfThumbnails({});
            setSelectedMail(item);
            setShowMailHeaderDetails(false);
        } finally {
            setLoadingMailAttachments(false);
            stopHudRotation();
        }
    };

    const handleCloseMailDetails = () => {
        setSelectedMail(null);
        setMailAttachments([]);
        setLoadingMailAttachments(false);
        setPdfThumbnails({});
        setShowMailHeaderDetails(false);
    };

    useEffect(() => {
        if (!selectedMail || mailAttachments.length === 0) return;
        let cancelled = false;

        const generateThumbs = async () => {
            const pdfItems = mailAttachments.filter((att) => isPdfAttachment(att.name));
            for (const attachment of pdfItems) {
                if (pdfThumbnails[attachment.key]) continue;
                try {
                    const thumb = await createPdfThumbnail(attachment.url);
                    if (!cancelled) {
                        setPdfThumbnails((prev) => ({ ...prev, [attachment.key]: thumb }));
                    }
                } catch (error) {
                    console.warn("Unable to generate PDF thumbnail", attachment.name, error);
                    // fallback handled by static icon if thumbnail generation fails
                }
            }
        };

        generateThumbs();
        return () => {
            cancelled = true;
        };
    }, [selectedMail, mailAttachments, pdfThumbnails]);

    useEffect(() => {
        if (!showMailHeaderDetails) return;

        const handleClickOutsideHeaderDetails = (event) => {
            const clickedInsideToggle = mailHeaderToggleRef.current?.contains(event.target);
            const clickedInsideDetails = mailHeaderDetailsRef.current?.contains(event.target);

            if (!clickedInsideToggle && !clickedInsideDetails) {
                setShowMailHeaderDetails(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutsideHeaderDetails);
        return () => {
            document.removeEventListener("mousedown", handleClickOutsideHeaderDetails);
        };
    }, [showMailHeaderDetails]);

    const handleOpenChequeModal = () => {
        setChequeData(null);
        setChequePaymentTo("");
        setChequeAmount("");
        setChequeMemo("");
        setChequeAddress({ address: "", city: "", state: "", zip: "" });
        fetchAgencyAddress(record.agencyID);
        setShowChequeModal(true);
        setChequeErrors({});
    };

    const handleViewCheque = async (cheque) => {
        if (!cheque?.s3Key) return;
        hud("Loading Cheque...");
        try {

            const req = {
                s3Key: cheque.s3Key,
                datasetID: record.datasetID,
                datasetName: record.datasetName
            }

            const response = await requestSentDS.WS_OutgoingRequest_Cheque_PresignedUrl_GET(req);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200 && body.presignedUrl) {
                setChequePdfUrl(body.presignedUrl);
                setViewChequeRequestId(record.requestID);
                setShowViewChequeModal(true);
                insertLog(
                    `${userName} viewed cheque for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.requestID || '',
                    'GET',
                    'WS_OutgoingRequest_Cheque_PresignedUrl_GET',
                    'SUCCESS',
                    ''
                );
            }
            else {
                insertLog(
                    `${userName} failed to view cheque for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.requestID || '',
                    'GET',
                    'WS_OutgoingRequest_Cheque_PresignedUrl_GET',
                    'FAILED',
                    'Unable to load cheque'
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to view cheque for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.requestID || '',
                'GET',
                'WS_OutgoingRequest_Cheque_PresignedUrl_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Failed.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
        } finally { stopHudRotation(); }
    };

    const fetchAgencyAddress = async (agencyID) => {
        try {
            if (!agencyID) { showToast({ message: "Agency ID missing" }); return; }
            hud("Loading agency details...");
            const response = await requestSentDS.WS_Agency_Address_ById_GET({ agencyID });
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200 && body?.record) {
                const rec = body.record;
                setChequePaymentTo(rec.agencyDisplayName || "");
                setChequeAddress({
                    address: rec.agencyAddress?.address || "",
                    city: rec.agencyAddress?.city || "",
                    state: rec.agencyAddress?.state || "",
                    zip: rec.agencyAddress?.zip || ""
                });
                insertLog(
                    `${userName} fetched agency address for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    agencyID || '',
                    'GET',
                    'WS_Agency_Address_ById_GET',
                    'SUCCESS',
                    ''
                );
            } else {
                showToast({ message: "Agency record not found" });
                insertLog(
                    `${userName} failed to fetch agency address for agency '${agencyID}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    agencyID || '',
                    'GET',
                    'WS_Agency_Address_ById_GET',
                    'FAILED',
                    'Agency address not found'
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch agency address for agency '${agencyID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                agencyID || '',
                'GET',
                'WS_Agency_Address_ById_GET',
                'FAILED',
                err.message
            );
            console.error("Error fetching agency address:", err);
            showToast({ message: "Error fetching agency details" });
        } finally { stopHudRotation(); }
    };

    const handleGenerateCheque = async (e) => {
        e.preventDefault();

        const newErrors = {};

        if (!chequePaymentTo?.trim()) {
            newErrors.chequePaymentTo = "Payable To is required";
        }

        if (!chequeAmount?.trim()) {
            newErrors.chequeAmount = "Amount is required";
        }

        if (!chequeAddress.address?.trim()) {
            newErrors.address = "Address is required";
        }

        if (!chequeAddress.city?.trim()) {
            newErrors.city = "City is required";
        }

        if (!chequeAddress.state?.trim()) {
            newErrors.state = "State is required";
        }

        if (!chequeAddress.zip?.trim()) {
            newErrors.zip = "Zip is required";
        }

        setChequeErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            return;
        }

        hud("Generating Cheque...");
        try {
            const req = {
                requestID: record._id,
                datasetID: record.datasetID,
                datasetName: record.datasetName,
                cheque: {
                    payableTo: chequePaymentTo,
                    amount: parseFloat(chequeAmount),
                    amountInWords: numberToWords(parseFloat(chequeAmount)),
                    address: chequeAddress,
                    memo: chequeMemo,
                    created_by_email_id: useremail
                }
            };
            const response = await requestSentDS.WS_OutgoingRequest_Cheque_Generate(req);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200) {
                showToast({ message: "Cheque generated and uploaded successfully!" });
                setShowChequeModal(false);
                setChequePaymentTo("");
                setChequeAmount("");
                setChequeMemo("");
                setChequeAddress({ address: "", city: "", state: "", zip: "" });
                await refreshRecord();
                insertLog(
                    `${userName} generated a cheque for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.requestID || '',
                    'INSERT',
                    'WS_OutgoingRequest_Cheque_Generate',
                    'SUCCESS',
                    ''
                );
            } else {
                showAlert(body?.message || "Failed.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
                insertLog(
                    `${userName} failed to generate cheque for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.requestID || '',
                    'INSERT',
                    'WS_OutgoingRequest_Cheque_Generate',
                    'FAILED',
                    'Unable to generate cheque'
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to generate cheque for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.requestID || '',
                'INSERT',
                'WS_OutgoingRequest_Cheque_Generate',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Failed.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
        } finally { stopHudRotation(); }
    };

    const refreshRecord = async () => {
        try {
            const response = await requestSentDS.WS_OutgoingRequest_Details_GET({ requestID: record.requestID });
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            const actualRecord = body.requests || body;
            if (data.statusCode === 200 && actualRecord) {
                const updated = {
                    ...actualRecord,
                    id: actualRecord._id || actualRecord.id,
                    filesCount: actualRecord.filesCount ?? body.filesCount ?? 0,
                    casesCount: actualRecord.casesCount ?? body.casesCount ?? 0,
                    filesData: body.files || null,  // new: pull files object from top level
                };
                setRecord(updated);
                return updated;
            }
            console.warn("refreshRecord: record not found");
            return null;
        } catch (err) {
            insertLog(
                `${userName} failed to refresh record for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.id || '',
                'GET',
                'WS_OutgoingRequest_Details_GET',
                'FAILED',
                err.message
            );
            console.error("Refresh failed:", err);
            return null;
        }
    };

    const handleAmountChange = (e) => {
        if (/^\d*\.?\d*$/.test(e.target.value))
            setChequeAmount(e.target.value);
        if (chequeErrors.chequeAmount) {
            setChequeErrors(prev => ({
                ...prev,
                chequeAmount: ""
            }));
        }
    };

    const numberToWords = (amount) => {
        const integer = Math.floor(amount);
        const decimal = Math.round((amount - integer) * 100);
        return `${integer} DOLLARS${decimal > 0 ? ` AND ${decimal} CENTS` : ""}`;
    };

    return (
        <div className="main-content">

            <div className="p-2 custom-bg-white rounded d-flex align-items-center gap-3">

                {/* Back Button */}
                <button
                    className="back-btn_ticket"
                    onClick={() =>
                        navigate("/AgenctTicketHistory", {
                            state: {
                                ticketHistoryState: location.state?.ticketHistoryState
                            }
                        })
                    }                >
                    <IoIosArrowBack /> Back
                </button>

                {/* Header Details */}
                <div className="request-header-ticket">

                    <div className="ticket-item">
                        <span className="ticket-label">
                            Request Id:
                        </span>

                        <span className="ticket-value">
                            {record.requestID || "NA"}
                        </span>
                    </div>

                    <div className="ticket-item">
                        <span className="ticket-label">
                            Agency:
                        </span>

                        <span className="ticket-value">
                            {
                                record.agencyID &&
                                    record.agencyName
                                    ? `${record.agencyID} - ${record.agencyName}`
                                    : "NA"
                            }
                        </span>
                    </div>

                    <div className="ticket-item">
                        <span className="ticket-label">
                            Files & Cases:
                        </span>

                        <span className="ticket-value">
                            {/* {record.filesCount ?? "0"} / {record.casesCount ?? "0"} */}
                            {
                                (record.totalFilesCount || 0) === 0
                                    ? 'No Files'
                                    : (record.totalCasesCount || 0) === 0
                                        ? `${record.totalFilesCount} ${record.totalFilesCount === 1 ? 'File' : 'Files'} & Cases Yet to Start`
                                        : `${record.totalFilesCount} ${record.totalFilesCount === 1 ? 'File' : 'Files'} with ${record.totalCasesCount} ${record.totalCasesCount === 1 ? 'Case' : 'Cases'}`
                            }
                        </span>
                    </div>

                    <div className="ticket-item">
                        <span className="ticket-label">
                            Status:
                        </span>

                        <span className="ticket-value">
                            {
                                record.outgoingRequest_Status ||
                                "Sent"
                            }
                        </span>
                    </div>

                    <div className="ticket-item">
                        <span className="ticket-label">
                            Req PDF:
                        </span>

                        <span
                            className="ticket-value link"
                            onClick={() =>
                                handleViewPDF(record.pdfForm?.s3Key)
                            }
                        >
                            View PDF
                        </span>
                    </div>

                </div>
            </div>


            <div className="custom-bg-white main-content-2_ticket mt-4 p-3">
                <div className="inner-content_ticket">


                    {/* ── Section 1: Events ── */}
                    <div className="accordion-item1_ticket">
                        <div className="accordion-header_ticket" onClick={() => toggleSection("events")}>
                            <div className="header-left_ticket">
                                <span>Events</span>
                            </div>
                            <div className="header-right_ticket">
                                {openSection.includes("events") && (
                                    <span className="add-note-link_ticket" onClick={(e) => { e.stopPropagation(); setEventData({ startDateTime: "", endDateTime: "", message: "" }); setShowEventModal(true); setEventErrors({}); }}>
                                        + Add Event
                                    </span>
                                )}
                                <span>{openSection.includes("events") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                            </div>
                        </div>
                        {openSection.includes("events") && (
                            <div className="accordion-content_ticket">
                                {(record.events || []).length === 0 ? (
                                    <div className="empty-text_ticket">No events found.</div>
                                ) : (
                                    <div className="table-content-event">
                                        <table className="files-event-table">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Start Date Time</th>
                                                    <th>End Date Time</th>
                                                    <th>Message</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(record.events || []).map((ev, i) => (
                                                    <tr key={i}>
                                                        <td>{i + 1}</td>
                                                        <td>{ev.startDateTime ? formatToLocalDateTime(ev.startDateTime) : "NA"}</td>
                                                        <td>{ev.endDateTime ? formatToLocalDateTime(ev.endDateTime) : "NA"}</td>
                                                        <td>{ev.message || "NA"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ── Section 2: Cheques ── */}
                    <div className="accordion-item1_RD">

                        <div
                            className="accordion-header_RD"
                            onClick={() => toggleSection("cheque")}
                        >
                            <div className="header-left_RD">
                                <span>Cheque</span>
                            </div>

                            <div className="header-right_RD">

                                {openSection.includes("cheque") && (
                                    <span
                                        className="add-note-link_RD"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenChequeModal();
                                        }}
                                    >
                                        + Add Cheque
                                    </span>
                                )}

                                <span>
                                    {openSection.includes("cheque")
                                        ? <IoIosArrowUp />
                                        : <IoIosArrowDown />}
                                </span>
                            </div>
                        </div>

                        {openSection.includes("cheque") && (

                            <div className="accordion-content_RD_cheques">

                                {(!record.cheques || record.cheques.length === 0) ? (

                                    <div className="py-3 empty-text_RD">
                                        No cheque added.
                                    </div>

                                ) : (

                                    <div className="files-event-table-wrapper">

                                        <table className="files-event-table">

                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Payable To</th>
                                                    <th>Amount</th>
                                                    <th>Memo</th>
                                                    <th>Generated By</th>
                                                    <th>Generated On</th>
                                                    <th>View</th>
                                                </tr>
                                            </thead>

                                            <tbody>

                                                {/* {(record.cheque || []).map((cheque, index) => ( */}

                                                {(
                                                    Array.isArray(record.cheques)
                                                        ? record.cheques
                                                        : typeof record.cheques === "string"
                                                            ? JSON.parse(record.cheques)
                                                            : [record.cheques]
                                                ).map((cheque, index) => (

                                                    <tr key={index}>

                                                        <td>
                                                            {index + 1}
                                                        </td>

                                                        <td>
                                                            {cheque.payableTo || "NA"}
                                                        </td>

                                                        <td>
                                                            {cheque.amount || "NA"}
                                                        </td>

                                                        <td>
                                                            {cheque.memo || "NA"}
                                                        </td>

                                                        <td>
                                                            {cheque.created_by_email_id || "NA"}
                                                        </td>

                                                        <td>
                                                            {
                                                                formatToLocalDateTime(
                                                                    cheque.generatedOn?.$date ||
                                                                    cheque.generatedOn
                                                                ) || "NA"
                                                            }
                                                        </td>

                                                        <td>
                                                            {cheque?.s3Key ? (
                                                                <FaEye
                                                                    size={16}
                                                                    className="adp-cheque-view-btn"
                                                                    title="View Cheque"
                                                                    onClick={() => handleViewCheque(cheque)}
                                                                />
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </td>

                                                    </tr>

                                                ))}

                                            </tbody>

                                        </table>

                                    </div>

                                )}

                            </div>

                        )}

                    </div>

                    {/* ── Section 3: Notes ── */}
                    <div className="accordion-item1_ticket">
                        <div className="accordion-header_ticket" onClick={() => toggleSection("notes")}>
                            <div className="header-left_ticket">
                                <span>Notes</span>
                            </div>
                            <div className="header-right_ticket">
                                {openSection.includes("notes") && (
                                    <span className="add-note-link_ticket" onClick={(e) => { e.stopPropagation(); setTextArea(""); setShowAddModal(true); setNotesError({}); setIsPinned(false); }}>
                                        + Add Note
                                    </span>
                                )}
                                <span>{openSection.includes("notes") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                            </div>
                        </div>

                        {openSection.includes("notes") && (
                            <div className="accordion-content_ticket">
                                {notes.length === 0 ? (
                                    <p style={{ color: "#888", fontSize: 13 }}>No notes yet.</p>
                                ) : (
                                    <div className="notes-view-body_RD">
                                        {[...notes]
                                            .sort((a, b) => (b.isPinned ? 1 : 0) - (a.isPinned ? 1 : 0))
                                            .map((note, idx) => {
                                                const rawText = note.text || "";
                                                const first50 = rawText.substring(0, 50);
                                                const matchedStatus = viewHighlightFileds.find(s => first50.startsWith(s));
                                                return (
                                                    <div key={idx} className="note-item_RD">
                                                        <p className="note-text_RD">
                                                            {note.isPinned && (
                                                                <span style={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    gap: 3,
                                                                    background: "#fff3cd",
                                                                    color: "#b45309",
                                                                    fontSize: 10,
                                                                    fontWeight: 600,
                                                                    borderRadius: 4,
                                                                    padding: "1px 6px",
                                                                    marginRight: 5,
                                                                    border: "1px solid #fcd34d"
                                                                }}>
                                                                    <BsPinAngleFill size={10} /> Pinned
                                                                </span>
                                                            )}
                                                            <GoDotFill size={12} />{" "}
                                                            {matchedStatus ? (
                                                                <><span className="status-highlight_RD">{matchedStatus}</span>{" "}{rawText.substring(matchedStatus.length).trim()}</>
                                                            ) : rawText}
                                                        </p>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between"
                                                            }}
                                                        >
                                                            <p className="note-meta_RD" style={{ margin: 0 }}>
                                                                {note.updated_by_email_id} at{" "}
                                                                {formatToLocalDateTime(
                                                                    note.addedTimestamp?.$date || note.addedTimestamp
                                                                )}
                                                            </p>

                                                            <button
                                                                title={note.isPinned ? "Unpin note" : "Pin note"}
                                                                onClick={() => {
                                                                    const originalIndex =
                                                                        record.notes.findIndex(n => n === note);

                                                                    handlePinNote(
                                                                        originalIndex,
                                                                        note.isPinned
                                                                    );
                                                                }}
                                                                className={`pin-btn_RD ${note.isPinned ? "pinned" : ""}`}
                                                            >
                                                                {
                                                                    note.isPinned
                                                                        ? <BsPinAngleFill size={16} />
                                                                        : <BsPinAngle size={16} />
                                                                }
                                                            </button>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                )}
                            </div>
                        )}

                    </div>

                    {/* ── Section 4: Request Details ── */}

                    <div className="accordion-item1_ticket_RequestDetails">
                        <div
                            className={`accordion-header_RD_RequestDetails ${openSection.includes("requestResponse")
                                ? "expanded"
                                : "collapsed"
                                }`}
                            onClick={() => toggleSection("requestResponse")}
                        >
                            <span>Request Details</span>
                            <span>{openSection.includes("requestResponse") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                        </div>
                        {openSection.includes("requestResponse") && (
                            <div className="accordion-content_RD">

                                <div className="table-content-files">
                                    <table className="files-event-table">
                                        <thead>
                                            <tr>
                                                <th>Request Type</th>
                                                <th>Request Email Address</th>
                                                <th>Response Type</th>
                                                {/* <th>Response Email Address</th> */}
                                                <th>Trigger Events</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>

                                                {/* Request Type */}
                                                <td>
                                                    {record.requestMethod?.requestType || "NA"}
                                                </td>

                                                {/* Request Email */}
                                                {/* <td>
                                                    {Array.isArray(record.requestMethod?.emailSettings)
                                                        ? record.requestMethod.emailSettings.join(", ")
                                                        : "NA"}
                                                </td> */}
                                                <td className="email-cell">
                                                    {Array.isArray(record.requestMethod?.emailSettings) ? (
                                                        record.requestMethod.emailSettings.length === 1 ? (
                                                            // Single mail — just show text, no arrow no dropdown
                                                            <span className="email-primary" title={record.requestMethod.emailSettings[0]}>
                                                                {record.requestMethod.emailSettings[0]}
                                                            </span>
                                                        ) : (
                                                            // Multiple mails — arrow + dropdown
                                                            <div
                                                                className="email-dropdown-wrapper"
                                                                ref={requestDropdownRef}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    toggleEmailDropdown("request");
                                                                }}
                                                            >
                                                                <span className="email-primary">
                                                                    {record.requestMethod.emailSettings[0]}
                                                                </span>

                                                                <span className="email-badge">
                                                                    +{record.requestMethod.emailSettings.length - 1}
                                                                </span>

                                                                <IoIosArrowDown
                                                                    className={`email-more-icon ${openEmailDropdown === "request" ? "open" : ""}`}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                />

                                                                {openEmailDropdown === "request" && (
                                                                    <div className="email-dropdown-popup">
                                                                        {record.requestMethod.emailSettings.map((mail, i) => {
                                                                            const initials = mail
                                                                                .split("@")[0]
                                                                                .split(".")
                                                                                .map((p) => p[0]?.toUpperCase())
                                                                                .join("")
                                                                                .slice(0, 2);
                                                                            return (
                                                                                <div key={i} className="email-item-popup">
                                                                                    <div className="email-avatar">{initials}</div>
                                                                                    <span className="email-item-text" title={mail}>{mail}</span>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    ) : (
                                                        <span className="email-na">NA</span>
                                                    )}
                                                </td>

                                                {/* Response Type */}
                                                <td>
                                                    {record.requestMethod?.responseType || "NA"}
                                                </td>

                                                {/* Response Email */}
                                                {/* <td>
                                                    {Array.isArray(record.responseMethod?.emailSettings)
                                                        ? record.responseMethod.emailSettings.join(", ")
                                                        : "NA"}
                                                </td> */}
                                                {/* <td className="email-cell">
                                                    {Array.isArray(record.responseMethod?.emailSettings) ? (
                                                        record.responseMethod.emailSettings.length === 1 ? (
                                                            // Single mail — just show text, no arrow no dropdown
                                                            <span className="email-primary" title={record.responseMethod.emailSettings[0]}>
                                                                {record.responseMethod.emailSettings[0]}
                                                            </span>
                                                        ) : (
                                                            // Multiple mails — arrow + dropdown
                                                            <div
                                                                className="email-dropdown-wrapper"
                                                                ref={responseDropdownRef}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    toggleEmailDropdown("response");
                                                                }}
                                                            >
                                                                <span className="email-primary">
                                                                    {record.responseMethod.emailSettings[0]}
                                                                </span>

                                                                <span className="email-badge">
                                                                    +{record.responseMethod.emailSettings.length - 1}
                                                                </span>

                                                                <IoIosArrowDown
                                                                    className={`email-more-icon ${openEmailDropdown === "response" ? "open" : ""}`}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                />

                                                                {openEmailDropdown === "response" && (
                                                                    <div className="email-dropdown-popup">
                                                                        {record.responseMethod.emailSettings.map((mail, i) => {
                                                                            const initials = mail
                                                                                .split("@")[0]
                                                                                .split(".")
                                                                                .map((p) => p[0]?.toUpperCase())
                                                                                .join("")
                                                                                .slice(0, 2);
                                                                            return (
                                                                                <div key={i} className="email-item-popup">
                                                                                    <div className="email-avatar">{initials}</div>
                                                                                    <span className="email-item-text" title={mail}>{mail}</span>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    ) : (
                                                        <span className="email-na">NA</span>
                                                    )}
                                                </td> */}
                                                {/* Trigger Events */}
                                                <td>
                                                    {(record.TriggerEvents || []).length > 0 ? (
                                                        record.TriggerEvents.map((t, i) => (
                                                            <div key={i}>
                                                                {t.waitDays} {t.waitDays === 1 ? "Day" : "Days"} - {t.action}
                                                            </div>
                                                        ))
                                                    ) : (
                                                        "NA"
                                                    )}
                                                </td>

                                                {/* Status */}
                                                <td>
                                                    {record.outgoingRequest_Status}
                                                </td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        )}
                    </div>


                    {/* ── Section 5: Files ── */}
                    <div className="accordion-item1_ticket">
                        <div
                            className="accordion-header_RD"
                            onClick={() => toggleSection("files")} >
                            <span>Files</span>
                            <span>
                                {openSection.includes("files") ? <IoIosArrowUp /> : <IoIosArrowDown />}
                            </span>
                        </div>

                        {openSection.includes("files") && (
                            <div className="accordion-content_ticket">
                                {!files || files.length === 0 ? (
                                    <div className="empty-text_ticket">No file data available.</div>
                                ) : (
                                    <div className="table-content-files">
                                        <table className="files-event-table">
                                            <thead>
                                                <tr>
                                                    <th>File Name</th>
                                                    <th>Pages</th>
                                                    <th>Cases Count</th>
                                                    <th>Link</th>
                                                    <th>Received At</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(Array.isArray(files) ? files : [files]
                                                ).map((file, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {file.s3_url ? (
                                                                <a
                                                                    href={file.s3_url}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="request-value link"
                                                                >
                                                                    {file.file_name}
                                                                </a>
                                                            ) : "NA"}
                                                        </td>
                                                        <td>{file.pages ?? "NA"}</td>
                                                        <td>{file.casesCount ?? "NA"}</td>
                                                        <td>
                                                            {file.gmail_link ? (
                                                                <a
                                                                    href={file.gmail_link}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="request-value link"
                                                                >
                                                                    {file.gmail_link}
                                                                </a>
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </td>
                                                        <td>{file.created_at ? formatToLocalDateTime(file.created_at) : "NA"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        )}

                    </div>

                    {/* ── Section 6: HISTRORY ── */}
                    <div className="accordion-item1_ticket">
                        <div
                            className="accordion-header_RD"
                            onClick={handleHistoryToggle}
                        >
                            <span>Call History</span>
                            <span>
                                {openSection.includes("history") ? <IoIosArrowUp /> : <IoIosArrowDown />}
                            </span>
                        </div>

                        {openSection.includes("history") && (
                            <div className="call-history-body-ticket">
                                {record && shouldShowCallAction(record) && (
                                    <div className="call-action-container-ticket">
                                        <button className="call-action-btn-ticket"
                                            onClick={handleOpenCallforAction}>
                                            <BiSolidPhoneCall className="call-btn-icon-ticket" />
                                            Call for Action
                                        </button>
                                    </div>
                                )}

                                {(!callHistory || callHistory.length === 0) ? (
                                    <div className="empty-text_ticket">
                                        <p>No call history found.</p>
                                    </div>
                                ) : (
                                    <div className="call-history-cards-ticket">
                                        {callHistory.map((item, index) => {
                                            const total = Math.floor(item.call_duration || 0);
                                            const mins = String(Math.floor(total / 60)).padStart(2, "0");
                                            const secs = String(total % 60).padStart(2, "0");

                                            const duration = `${mins}:${secs}`;
                                            const date = item.updated_at
                                                ? new Date(item.updated_at).toLocaleString()
                                                : "—";
                                            const avatarLetter = (item.agent_email || "?")[0].toUpperCase();


                                            return (
                                                <div className="call-history-card-ticket" key={item._id || index}>

                                                    <audio
                                                        ref={audioRef}
                                                        onEnded={() => {
                                                            setIsPlaying(false);
                                                            setPlayingId(null);
                                                        }}
                                                    />

                                                    {/* ── Top color strip ── */}
                                                    <div className="call-history-card-strip-ticket" />

                                                    {/* ── Card Header ── */}
                                                    <div className="call-history-card-header-ticket">
                                                        <div className="call-history-agent-ticket">


                                                            {item.call_s3_key && item.call_analysis_data && (
                                                                <div className="call-history-recording-row-ticket">
                                                                    <button
                                                                        className="call-history-play-btn-ticket"
                                                                        onClick={() => {
                                                                            handlePlay(item.call_s3_key, item._id);
                                                                            setModalItem(item);
                                                                            setModalOpen(true);
                                                                        }}
                                                                    >
                                                                        {playingId === item._id && isPlaying ? "⏸" : "▶"}
                                                                    </button>
                                                                </div>
                                                            )}
                                                            <div>
                                                                <div className="call-history-agent-email-ticket">
                                                                    {item.agent_email || "-"}
                                                                </div>
                                                                <div className="call-history-date-ticket">🕐 {date}</div>
                                                            </div>
                                                        </div>
                                                        {
                                                            !item.call_analysis_data && (
                                                                <div className="call-history-recording-row-ticket">
                                                                    <span style={{ fontSize: "12px" }}>No Recording</span>
                                                                </div>
                                                            )
                                                        }
                                                        {item.call_ && (
                                                            <div className="call-history-duration-badge-ticket">
                                                                ⏱ {duration}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* ── Card Body ── */}
                                                    <div className="call-history-card-body-ticket">

                                                        {/* From / To row */}
                                                        <div className="call-history-info-row-ticket">
                                                            <div className="call-history-info-box-ticket">
                                                                <span className="call-history-info-icon-ticket">
                                                                    <FiPhoneOutgoing style={{ color: "#1976d2" }} />
                                                                </span>
                                                                <div>
                                                                    <span className="call-history-label-ticket">From</span>
                                                                    <span className="call-history-value-ticket">{item.called_from || "—"}</span>
                                                                </div>
                                                            </div>
                                                            <div className="call-history-info-divider-ticket" />
                                                            <div className="call-history-info-box-ticket">
                                                                <span className="call-history-info-icon-ticket">
                                                                    <FiPhone style={{ color: "#2e7d32" }} />
                                                                </span>
                                                                <div>
                                                                    <span className="call-history-label-ticket">To</span>
                                                                    <span className="call-history-value-ticket">{item.called_to || "—"}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Notes */}
                                                        <div className="call-history-notes-box-ticket">
                                                            <span className="call-history-label-ticket">📝 Notes</span>
                                                            <p className="call-history-notes-text-ticket">
                                                                {item.notes || "No notes added."}
                                                            </p>
                                                        </div>
                                                        <div
                                                            className="ca-trigger-row-ticket"
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                gap: 8,
                                                                width: "100%"
                                                            }}
                                                        >
                                                            {/* Call Status should show for ALL cards */}
                                                            {item.call_status && (
                                                                <span
                                                                    style={{
                                                                        fontSize: 11,
                                                                        fontWeight: 500,

                                                                        color:
                                                                            item.call_status === "Unable to contact"
                                                                                ? "#d32f2f"
                                                                                : item.call_status === "Left voice message"
                                                                                    ? "#1976d2"
                                                                                    : item.call_status === "Spoke to person"
                                                                                        ? "#2e7d32"
                                                                                        : "#555",

                                                                        background:
                                                                            item.call_status === "Unable to contact"
                                                                                ? "#fdecea"
                                                                                : item.call_status === "Left voice message"
                                                                                    ? "#e3f2fd"
                                                                                    : item.call_status === "Spoke to person"
                                                                                        ? "#e8f5e9"
                                                                                        : "#f5f5f5",

                                                                        border:
                                                                            item.call_status === "Unable to contact"
                                                                                ? "1px solid #ef9a9a"
                                                                                : item.call_status === "Left voice message"
                                                                                    ? "1px solid #90caf9"
                                                                                    : item.call_status === "Spoke to person"
                                                                                        ? "1px solid #81c784"
                                                                                        : "1px solid #d1d5db",

                                                                        borderRadius: 6,
                                                                        padding: "3px 10px",
                                                                        whiteSpace: "nowrap"
                                                                    }}
                                                                >
                                                                    {item.call_status}
                                                                </span>
                                                            )}

                                                            {/* Analysis button only when analysis exists */}
                                                            {item.call_analysis_data && (
                                                                <button
                                                                    className="ca-trigger-btn-ticket"
                                                                    onClick={() =>
                                                                        setExpandedAnalysis(prev =>
                                                                            prev === item._id ? null : item._id
                                                                        )
                                                                    }
                                                                >
                                                                    <MdOutlineAnalytics size={11} />
                                                                    <span>Analysis</span>

                                                                    <FiChevronDown
                                                                        size={10}
                                                                        style={{
                                                                            transition: "transform 0.2s",
                                                                            transform:
                                                                                expandedAnalysis === item._id
                                                                                    ? "rotate(180deg)"
                                                                                    : "rotate(0deg)"
                                                                        }}
                                                                    />
                                                                </button>
                                                            )}
                                                        </div>

                                                        {item.call_analysis_data && expandedAnalysis === item._id &&
                                                            ReactDOM.createPortal(
                                                                <>
                                                                    <div className="ca-backdrop-ticket" />
                                                                    <div className="ca-modal-ticket">

                                                                        {/* ── Modal Header ── */}
                                                                        <div className="ca-modal-header-ticket">
                                                                            <div className="ca-modal-title-ticket">
                                                                                <MdOutlineAnalytics size={15} />
                                                                                <span>Call Details</span>
                                                                            </div>
                                                                            <button className="ca-modal-close-ticket" onClick={closeAnalysisModal}>
                                                                                <MdCancel size={13} />
                                                                            </button>
                                                                        </div>

                                                                        {/* ── Two column layout ── */}
                                                                        <div className="ca-modal-body-ticket">

                                                                            {/* ══ LEFT COLUMN: Card Info ══ */}
                                                                            <div className="ca-col ca-col-left-ticket">

                                                                                {/* Agent + Duration */}
                                                                                <div className="ca-section-label-ticket">
                                                                                    <FiVolume2 size={10} /> Audio Recording
                                                                                </div>
                                                                                <div className="ca-info-header-ticket">
                                                                                    {item.call_s3_key ? (
                                                                                        <button
                                                                                            className="ca-play-btn-ticket"
                                                                                            onClick={() => {
                                                                                                handlePlay(item.call_s3_key, item._id);
                                                                                                setModalItem(item);
                                                                                                setModalOpen(true);
                                                                                            }}
                                                                                        >
                                                                                            {playingId === item._id && isPlaying
                                                                                                ? <FiPause size={15} />
                                                                                                : <FiPlay size={15} />
                                                                                            }

                                                                                        </button>
                                                                                    ) : (
                                                                                        <div className="ca-no-avatar-ticket">
                                                                                            <FiMicOff size={15} />No recording available
                                                                                        </div>
                                                                                    )}
                                                                                    <div className="ca-agent-info-ticket">
                                                                                        <span className="ca-agent-name-ticket">{item.agent_email || "—"}</span>
                                                                                        <span className="ca-agent-date-ticket">
                                                                                            <FiClock size={10} />
                                                                                            {item.updated_at ? new Date(item.updated_at).toLocaleString() : "—"}
                                                                                        </span>
                                                                                    </div>

                                                                                    {item.call_s3_key && (
                                                                                        <div className="ca-duration-pill-ticket">
                                                                                            <FiClock size={10} />
                                                                                            <span>{duration}</span>
                                                                                        </div>
                                                                                    )}
                                                                                </div>


                                                                                {/* From / To */}
                                                                                <div className="ca-section-label-ticket">
                                                                                    <FiPhone size={10} /> Call Route
                                                                                </div>
                                                                                <div className="ca-from-to-ticket">
                                                                                    <div className="ca-route-box-ticket from">
                                                                                        <span className="ca-route-label-ticket">
                                                                                            <FiPhoneOutgoing size={10} /> From
                                                                                        </span>
                                                                                        <span className="ca-route-value-ticket">{item.called_from || "—"}</span>
                                                                                    </div>
                                                                                    <div className="ca-route-arrow-ticket">
                                                                                        <FiArrowRight size={14} />
                                                                                    </div>
                                                                                    <div className="ca-route-box-ticket to">
                                                                                        <span className="ca-route-label-ticket">
                                                                                            <FiPhoneIncoming size={10} /> To
                                                                                        </span>
                                                                                        <span className="ca-route-value-ticket">{item.called_to || "—"}</span>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Notes */}
                                                                                <div className="ca-section-label-ticket">
                                                                                    <FiFileText size={10} /> Notes
                                                                                </div>
                                                                                <p className="ca-notes-text-ticket">{item.notes || "No notes added."}</p>

                                                                                {/* Issues */}
                                                                                {item.call_analysis_data.call_issues && (
                                                                                    <>
                                                                                        <div className="ca-section-label-ticket issues-label">
                                                                                            <FiAlertCircle size={10} /> Issues
                                                                                        </div>
                                                                                        <p className="ca-block-text-ticket issues">{item.call_analysis_data.call_issues}</p>
                                                                                    </>
                                                                                )}
                                                                            </div>

                                                                            {/* ══ RIGHT COLUMN: Analysis ══ */}
                                                                            <div className="ca-col ca-col-right-ticket">

                                                                                {/* Sentiments */}
                                                                                <div className="ca-section-label">
                                                                                    <BsRobot size={10} /> Call Analysis
                                                                                </div>
                                                                                <div className="ca-sentiment-row-ticket">
                                                                                    <div className="ca-sentiment-ticket agent">
                                                                                        <RiCustomerService2Fill size={15} />
                                                                                        <div>
                                                                                            <span className="ca-sent-label-ticket">Agent</span>
                                                                                            <span className="ca-sent-value-ticket">{item.call_analysis_data.agent_sentiment || "—"}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="ca-sentiment-ticket customer">
                                                                                        <BsPerson size={15} />
                                                                                        <div>
                                                                                            <span className="ca-sent-label-ticket">Customer</span>
                                                                                            <span className="ca-sent-value-ticket">{item.call_analysis_data.customer_sentiment || "—"}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Summary */}
                                                                                {item.call_analysis_data.call_summary && (
                                                                                    <>
                                                                                        <div className="ca-section-label-ticket">
                                                                                            <FiFileText size={10} /> Summary
                                                                                        </div>
                                                                                        <p className="ca-block-text-ticket">{item.call_analysis_data.call_summary}</p>
                                                                                    </>
                                                                                )}



                                                                                {/* Transcript */}
                                                                                {item.call_analysis_data.call_transcript?.length > 0 && (
                                                                                    <>
                                                                                        <div className="ca-section-label-ticket">
                                                                                            <FiMessageSquare size={10} /> Transcript
                                                                                        </div>
                                                                                        <div className="ca-transcript-list-ticket">
                                                                                            {item.call_analysis_data.call_transcript.map((line, i) => {
                                                                                                const isCustomer = line.startsWith("Customer:");
                                                                                                const text = line.replace(/^(Customer|Agent):\s*/, "");
                                                                                                return (
                                                                                                    <div key={i} className={`ca-bubble-row-ticket ${isCustomer ? "agent" : "customer"}`}>
                                                                                                        <div className="ca-bubble-ticket">
                                                                                                            <span className="ca-speaker-ticket">
                                                                                                                {isCustomer ? <><BsPerson size={9} /> Customer</> : <><RiCustomerService2Fill size={9} /> Agent</>}
                                                                                                            </span>
                                                                                                            <p className="ca-bubble-text-ticket">{text}</p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                );
                                                                                            })}
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>,
                                                                document.body
                                                            )
                                                        }

                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ── Section 7: Mail ── */}
                    <div className="accordion-item1_ticket">
                        <div className="accordion-header_RD" onClick={handleMailHistory}>
                            <span>Mail History</span>
                            <span>{openSection.includes("mail") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                        </div>

                        {openSection.includes("mail") && (
                            <div className="email-history-body">

                                <div className="email-action-container">

                                    <div className="view-toggle-btns">
                                        <button
                                            className={`view-toggle-btn ${viewMode === "grid" ? "active" : ""}`}
                                            onClick={() => setViewMode("grid")}
                                            title="Grid View"
                                        >
                                            <BsGrid3X3Gap />
                                        </button>
                                        <button
                                            className={`view-toggle-btn ${viewMode === "list" ? "active" : ""}`}
                                            onClick={() => setViewMode("list")}
                                            title="List View"
                                        >
                                            <FaList />
                                        </button>
                                    </div>
                                    <button
                                        className="email-action-btn"
                                        onClick={handleOpenMail}
                                    >
                                        <IoMdMail className="email-btn-icon" />
                                        Send Email
                                    </button>
                                </div>

                                {mailHistory.length === 0 ? (

                                    <div className="mail-history-empty">
                                        <div className="mail-history-empty-icon">✉</div>
                                        <p>No mail history found</p>
                                    </div>

                                ) : (

                                    <div className={
                                        viewMode === "grid"
                                            ? "mail-history-grid"
                                            : "mail-history-list"
                                    }>
                                        {mailHistory.map((item, index) => {
                                            // Determine status label
                                            const getStatusInfo = (item) => {
                                                console.log("scheduleTime:", item.scheduleTime);
                                                console.log("isScheduled:", item.isScheduled);

                                                if (!item.isScheduled) {
                                                    return { label: "Sent", className: "sent" };
                                                }

                                                const scheduleTimeUTC = new Date(item.scheduleTime).getTime();
                                                const nowUTC = Date.now();

                                                if (nowUTC >= scheduleTimeUTC) {
                                                    return { label: "Scheduled Sent", className: "scheduled-sent" };
                                                } else {
                                                    return { label: "Scheduled", className: "scheduled" };
                                                }
                                            };

                                            const statusInfo = getStatusInfo(item);
                                            const attachmentNames = item.attachmentNames?.length ? item.attachmentNames : ["Attachment"];
                                            const visibleAttachmentNames = attachmentNames.slice(0, 3);
                                            const hiddenAttachmentCount = Math.max(attachmentNames.length - 3, 0);

                                            return (

                                                viewMode === "grid" ? (

                                                    <div className="mail-history-item-grid" key={item._id || index}
                                                        onClick={() => handleOpenMailDetails(item)}
                                                        style={{ cursor: "pointer" }}>
                                                        <div className="mail-item-content-grid">

                                                            <div className="mail-item-top-grid">
                                                                <span className="mail-item-subject-grid">
                                                                    {item.subject}
                                                                </span>

                                                            </div>

                                                            <div className="mail-item-to-grid">
                                                                To: {item.recipients?.join(", ")}
                                                            </div>
                                                            <div className="mail-item-date-grid">
                                                                <span className={`mail-item-date-label-grid ${statusInfo.className}`}>
                                                                    {statusInfo.label === "Scheduled" ? "Scheduled:"
                                                                        : statusInfo.label === "Scheduled Sent" ? "Scheduled Sent:"
                                                                            : "Sent:"}
                                                                </span>
                                                                {statusInfo.label === "Sent"
                                                                    ? new Date(item.sentAt).toLocaleString()
                                                                    : new Date(item.scheduleTime).toLocaleString()
                                                                }
                                                            </div>

                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="mail-history-item mail-history-item-clickable"
                                                        key={item._id || index}
                                                        onClick={() => handleOpenMailDetails(item)}
                                                    >
                                                        <div className="mailShare-toggle"><TbMailShare /></div>
                                                        <div className="mail-item-content">
                                                            <div className="mail-item-to">
                                                                <span>To: </span>
                                                                {getMailToLabel(item)}
                                                            </div>

                                                            <div className="mail-item-subject">
                                                                {item.subject || "No Subject"}
                                                            </div>

                                                            <div className="mail-item-snippet">
                                                                {getMailSnippet(item) || "No preview available"}
                                                            </div>

                                                            {item.hasAttachment && (
                                                                <div className="mail-item-attachments-row">
                                                                    {visibleAttachmentNames.map((fileName, idx) => (
                                                                        <button
                                                                            type="button"
                                                                            className="mail-item-attachment-chip"
                                                                            key={`${item._id || index}-att-${idx}`}
                                                                            onClick={(e) => handleAttachmentClick(e, item, fileName, idx)}
                                                                            title={fileName}
                                                                        >
                                                                            <span className="mail-item-attachment-type">{getAttachmentTypeLabel(fileName)}</span>
                                                                            <span className="mail-item-attachment-name">{getAttachmentLabel(fileName)}</span>
                                                                        </button>
                                                                    ))}
                                                                    {hiddenAttachmentCount > 0 && (
                                                                        <span className="mail-item-attachment-more" title={`${hiddenAttachmentCount} more attachments`}>
                                                                            +{hiddenAttachmentCount}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="mail-item-meta">
                                                            <div className="mail-item-date">
                                                                <span className={`mail-item-status ${statusInfo.className}`}>
                                                                    {statusInfo.label}
                                                                </span>
                                                                <span>
                                                                    {statusInfo.label === "Sent"
                                                                        ? new Date(item.sentAt).toLocaleString()
                                                                        : new Date(item.scheduleTime).toLocaleString()}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )

                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>


                </div>
            </div>




            {showAddModal && (
                <div className="add-text-req_ticket">
                    <div className="add-text-req-body_ticket">
                        <div className="add-text-reqheader_ticket">
                            <span>Add Note</span>
                            <MdCancel size={24} className="closeAddForm_ticket" onClick={() => setShowAddModal(false)} />
                        </div>
                        <form onSubmit={handleTextSubmit}>
                            <div className="req-text-field_ticket">
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: 4
                                    }}
                                >
                                    <label className="form-label" style={{ margin: 0 }}>
                                        Note
                                        <span className="asterisk-req_ticket">
                                            <FaAsterisk />
                                        </span>
                                    </label>

                                    <button
                                        type="button"
                                        title={isPinned ? "Unpin this note" : "Pin this note to top"}
                                        onClick={() => setIsPinned(p => !p)}
                                        style={{
                                            background: isPinned ? "#fff3cd" : "#f5f5f5",
                                            border: isPinned
                                                ? "1px solid #f59e0b"
                                                : "1px solid #cbd5e1",
                                            borderRadius: 6,
                                            cursor: "pointer",
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: isPinned ? "#b45309" : "#374151",
                                            padding: "3px 10px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 6,
                                            transition: "all 0.2s"
                                        }}
                                    >
                                        {
                                            isPinned
                                                ? <BsPinAngleFill size={14} />
                                                : <BsPinAngle size={14} />
                                        }

                                        {isPinned ? "Pinned" : "Pin"}
                                    </button>
                                </div>
                                <textarea
                                    className={`form-control ${notesError.text ? "is-invalid" : ""}`}
                                    rows={3}
                                    value={textArea}
                                    placeholder="Enter notes"
                                    onChange={(e) => {

                                        setTextArea(e.target.value);

                                        if (notesError.text) {
                                            setNotesError(prev => ({
                                                ...prev,
                                                text: ""
                                            }));
                                        }
                                    }}
                                />

                                {notesError.text && (
                                    <div className="error-details">
                                        {notesError.text}
                                    </div>
                                )}
                                <button type="submit" className="req-text-field-btn_ticket mt-3">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {showEventModal && (
                <div className="add-text-req_ticket">
                    <div className="add-text-req-body_ticket">
                        <div className="add-text-reqheader_ticket">
                            <span>Add Event</span>
                            <MdCancel size={24} className="closeAddForm_ticket" onClick={() => setShowEventModal(false)} />
                        </div>
                        <form onSubmit={handleEventSubmit}>
                            <div className="req-text-field_ticket">

                                <label className="form-label">Start Date Time <span style={{ color: "red" }}>*</span></label>
                                <input type="datetime-local"
                                    className={`form-control ${eventErrors.startDateTime ? "is-invalid" : ""}`}
                                    value={eventData.startDateTime}
                                    onChange={(e) => {
                                        setEventData({
                                            ...eventData,
                                            startDateTime: e.target.value
                                        });
                                        if (eventErrors.startDateTime) setEventErrors(p => ({ ...p, startDateTime: "" }));
                                    }} />

                                {eventErrors.startDateTime && <div className="error-details">{eventErrors.startDateTime}</div>}

                                <label className="form-label mt-3">End Date Time <span style={{ color: "red" }}>*</span></label>
                                <input type="datetime-local"
                                    className={`form-control ${eventErrors.endDateTime ? "is-invalid" : ""}`}
                                    value={eventData.endDateTime}
                                    onChange={(e) => {
                                        setEventData({ ...eventData, endDateTime: e.target.value });
                                        if (eventErrors.endDateTime)
                                            setEventErrors(p => ({ ...p, endDateTime: "" }));
                                    }} />

                                {eventErrors.endDateTime && <div className="error-details">{eventErrors.endDateTime}</div>}

                                <label className="form-label mt-3">Message <span style={{ color: "red" }}>*</span></label>
                                <input type="text"
                                    className={`form-control event-message ${eventErrors.message ? "is-invalid" : ""}`}
                                    placeholder="Enter message"
                                    value={eventData.message}
                                    onChange={(e) => {
                                        setEventData({ ...eventData, message: e.target.value });
                                        if (eventErrors.message)
                                            setEventErrors(p => ({ ...p, message: "" }));
                                    }} />

                                {eventErrors.message && <div className="error-details">{eventErrors.message}</div>}


                                <button type="submit" className="req-text-field-btn_RD mt-3">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}




            {showMailModal && (

                <SendEmail
                    vin={record.requestID}
                    datasetID={emailDatasetID}
                    datasetName={emailDatasetName}
                    agencyName={record.agencyName}
                    fromEmail={record?.responseMethod?.emailSettings?.[0]}
                    toEmails={toEmails}
                    onClose={() => setShowMailModal(false)}
                    waitDays={callAndMailSettings}
                    mailHistory={mailHistory}
                    refreshMailHistory={fetchMailHistory}

                />
            )}

            {selectedMail && (
                <div className="mail-open-overlay" onClick={handleCloseMailDetails}>
                    <div className="mail-open-modal" onClick={(e) => e.stopPropagation()}>
                        {(() => {
                            const mailContent = getMailContent(selectedMail);
                            return (
                                <>
                                    <div className="mail-open-toolbar">
                                        <button type="button" className="mail-tool-icon" onClick={handleCloseMailDetails} aria-label="Back">
                                            <MdCancel size={25} />
                                        </button>
                                        {/* <button type="button" className="mail-tool-icon" aria-label="Archive"><GoArchive size={18} /></button>
                            <button type="button" className="mail-tool-icon" aria-label="Delete"><GoTrash size={18} /></button>
                            <button type="button" className="mail-tool-icon" aria-label="Later"><GoClock size={18} /></button>
                            <button type="button" className="mail-tool-icon" aria-label="Star"><GoStar size={18} /></button> */}
                                    </div>

                                    <div className="mail-open-header">
                                        <h4>{selectedMail.subject || "No Subject"}</h4>
                                    </div>

                                    <div className="mail-open-meta">
                                        <div className="mail-open-avatar">{getSenderInitial(selectedMail)}</div>
                                        <div className="mail-open-meta-content">
                                            <div className="mail-open-from-row">
                                                <strong>{getSenderDisplayName(selectedMail)}</strong>
                                                <span className="mail-open-from-address">&lt;{selectedMail.from || "NA"}&gt;</span>
                                                <span className="mail-open-time">{formatMailDateTime(selectedMail.sentAt || selectedMail.scheduleTime)}</span>
                                            </div>
                                            <button
                                                type="button"
                                                className="mail-open-to-toggle"
                                                ref={mailHeaderToggleRef}
                                                onClick={() => setShowMailHeaderDetails((prev) => !prev)}
                                                aria-expanded={showMailHeaderDetails}
                                            >
                                                <span className="mail-open-to-row">to {selectedMail.recipients?.join(", ") || "NA"}</span>
                                                {showMailHeaderDetails ? <IoIosArrowUp size={16} /> : <IoIosArrowDown size={16} />}
                                            </button>

                                            {showMailHeaderDetails && (
                                                <div className="mail-open-detail-card" ref={mailHeaderDetailsRef}>
                                                    <div className="mail-open-detail-row">
                                                        <span className="mail-open-detail-label">from:</span>
                                                        <span className="mail-open-detail-value">
                                                            <strong>{getSenderDisplayName(selectedMail)}</strong>
                                                            <span className="mail-open-detail-address">&lt;{selectedMail.from || "NA"}&gt;</span>
                                                        </span>
                                                    </div>
                                                    <div className="mail-open-detail-row">
                                                        <span className="mail-open-detail-label">to:</span>

                                                        <span className="mail-open-detail-value">
                                                            {selectedMail.recipients?.length > 0 ? (
                                                                selectedMail.recipients.map((mail, index) => (
                                                                    <div key={index}>{mail}{index !== selectedMail.recipients.length - 1 && ","}</div>
                                                                ))
                                                            ) : (
                                                                "NA"
                                                            )}
                                                        </span>
                                                    </div>

                                                    {selectedMail.ccrecipients?.length > 0 && (
                                                        <div className="mail-open-detail-row">
                                                            <span className="mail-open-detail-label">cc:</span>

                                                            <span className="mail-open-detail-value">
                                                                {selectedMail.ccrecipients.map((mail, index) => (
                                                                    <div key={index}>{mail}{index !== selectedMail.ccrecipients.length - 1 && ","}</div>
                                                                ))}
                                                            </span>
                                                        </div>
                                                    )}

                                                    {selectedMail.bccrecipients?.length > 0 && (
                                                        <div className="mail-open-detail-row">
                                                            <span className="mail-open-detail-label">bcc:</span>

                                                            <span className="mail-open-detail-value">
                                                                {selectedMail.bccrecipients.map((mail, index) => (
                                                                    <div key={index}>{mail}{index !== selectedMail.bccrecipients.length - 1 && ","}</div>
                                                                ))}
                                                            </span>
                                                        </div>
                                                    )}
                                                    <div className="mail-open-detail-row">
                                                        <span className="mail-open-detail-label">date:</span>
                                                        <span className="mail-open-detail-value">{formatMailDateTime(selectedMail.sentAt || selectedMail.scheduleTime)}</span>
                                                    </div>
                                                    <div className="mail-open-detail-row">
                                                        <span className="mail-open-detail-label">subject:</span>
                                                        <span className="mail-open-detail-value">{selectedMail.subject || "No Subject"}</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="mail-open-body">
                                        {mailContent.body ? (
                                            mailContent.isHtml ? (
                                                <div dangerouslySetInnerHTML={{ __html: mailContent.body }} />
                                            ) : (
                                                mailContent.body
                                            )
                                        ) : "No message content available."}
                                    </div>

                                    {mailAttachments.length > 0 && (
                                        <div className="mail-attachment-wrap">
                                            <div className="mail-attachment-title">
                                                <span>{mailAttachments.length} Attachment{mailAttachments.length > 1 ? "s" : ""}</span>
                                            </div>
                                            <div className="mail-attachment-list">
                                                {mailAttachments.map((attachment) => (
                                                    <a
                                                        key={attachment.key}
                                                        className="mail-attachment-card"
                                                        href={attachment.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        title={attachment.name}
                                                    >
                                                        <div className="mail-attachment-preview">
                                                            {isImageAttachment(attachment.name) ? (
                                                                <img
                                                                    src={attachment.url}
                                                                    alt={attachment.name}
                                                                    className="mail-attachment-thumb"
                                                                />
                                                            ) : isPdfAttachment(attachment.name) ? (
                                                                <div className="mail-attachment-pdf-preview">
                                                                    {pdfThumbnails[attachment.key] ? (
                                                                        <img
                                                                            src={pdfThumbnails[attachment.key]}
                                                                            alt={attachment.name}
                                                                            className="mail-attachment-thumb"
                                                                        />
                                                                    ) : (
                                                                        <MdAttachFile size={20} />
                                                                    )}
                                                                </div>
                                                            ) : isTextPreviewAttachment(attachment.name) ? (
                                                                <iframe
                                                                    src={attachment.url}
                                                                    title={attachment.name}
                                                                    className="mail-attachment-text-preview"
                                                                    sandbox=""
                                                                />
                                                            ) : (
                                                                <MdAttachFile size={22} />
                                                            )}
                                                            <div className="mail-attachment-hover-actions">
                                                                <button
                                                                    type="button"
                                                                    className="mail-attachment-action-btn"
                                                                    title="Download"
                                                                    onClick={(e) => handleDirectDownload(e, attachment.url, attachment.name)}
                                                                >
                                                                    <FiDownload size={14} />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="mail-attachment-action-btn"
                                                                    title="Open"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        window.open(attachment.url, "_blank", "noopener,noreferrer");
                                                                    }}
                                                                >
                                                                    <FiExternalLink size={14} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="mail-attachment-footer">
                                                            <span className="mail-attachment-ext">{getAttachmentTypeLabel(attachment.name)}</span>
                                                            <span className="mail-attachment-file">{attachment.name}</span>
                                                            <span className="mail-attachment-corner" />
                                                        </div>
                                                    </a>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    <div className="mail-open-actions">
                                        {/* <button type="button" className="mail-open-action-btn">Reply</button>
                            <button type="button" className="mail-open-action-btn">Forward</button>
                            <button type="button" className="mail-open-action-btn">Share in chat</button> */}
                                    </div>
                                </>
                            );
                        })()}
                    </div>
                </div>
            )}

            {/* ── Add Cheque Modal ── */}
            {showChequeModal && (
                <div className="notes-status-overlay_RD">
                    <div className="notes-status_RD">
                        <div className="notes-status-header_RD">
                            <span>{chequeData?.s3Key ? "View Cheque" : "Add Cheque"}</span>
                            <MdCancel size={24} className="closeAddForm_RD" onClick={() => setShowChequeModal(false)} />
                        </div>
                        <div className="notes-status-body_RD">
                            {chequeData?.s3Key ? (
                                <div className="submit-btn-container_RD">
                                    <button type="button" className="req-status-field-btn_RD" onClick={() => handleViewCheque(chequeData)}>
                                        View Cheque
                                    </button>
                                </div>
                            ) : (
                                <form onSubmit={handleGenerateCheque}>
                                    <div className="req-add-fieldcheque_RD">
                                        <div className="req-form-row_RD">
                                            <div className="req-status-field_RD">

                                                <label>Payable To <span className="asterisk-req_RD"><FaAsterisk /></span></label>

                                                <input type="text"
                                                    className={`form-control ${chequeErrors.chequePaymentTo ? "is-invalid" : ""}`}
                                                    placeholder="Enter payable to"
                                                    value={chequePaymentTo}
                                                    onChange={(e) => {
                                                        setChequePaymentTo(e.target.value);
                                                        if (chequeErrors.chequePaymentTo) {
                                                            setChequeErrors(prev => ({
                                                                ...prev,
                                                                chequePaymentTo: ""
                                                            }));
                                                        }
                                                    }}
                                                />
                                                {chequeErrors.chequePaymentTo && (
                                                    <div className="error-details">
                                                        {chequeErrors.chequePaymentTo}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="req-status-field_RD">

                                                <label>Amount <span className="asterisk-req_RD"><FaAsterisk /></span></label>
                                                <input type="text"
                                                    className={`form-control ${chequeErrors.chequeAmount ? "is-invalid" : ""}`}

                                                    placeholder="Enter amount"
                                                    value={chequeAmount}
                                                    onChange={handleAmountChange} />
                                                {chequeErrors.chequeAmount && (
                                                    <div className="error-details">
                                                        {chequeErrors.chequeAmount}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="req-form-row_RD">
                                            <div className="req-left-column_RD">
                                                <div className="req-status-field_RD address-field_RD">
                                                    <label>Address <span className="asterisk-req_RD"><FaAsterisk /></span></label>
                                                    <textarea
                                                        className={`form-control ${chequeErrors.address ? "is-invalid" : ""}`}
                                                        rows={2} placeholder="Enter address"
                                                        value={chequeAddress.address}
                                                        onChange={(e) => {
                                                            setChequeAddress({
                                                                ...chequeAddress,
                                                                address: e.target.value
                                                            });

                                                            if (chequeErrors.address) {
                                                                setChequeErrors(prev => ({
                                                                    ...prev,
                                                                    address: ""
                                                                }));
                                                            }
                                                        }} />

                                                    {chequeErrors.address && (
                                                        <div className="error-details">
                                                            {chequeErrors.address}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="req-status-field_RD">
                                                    <label>Memo</label>
                                                    <textarea className="form-control" rows={3} placeholder="Enter memo"
                                                        value={chequeMemo} onChange={(e) => setChequeMemo(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="req-right-column_RD">
                                                <div className="req-status-field_RD">
                                                    <label>City <span className="asterisk-req_RD"><FaAsterisk /></span></label>
                                                    <input
                                                        className={`form-control ${chequeErrors.city ? "is-invalid" : ""}`}
                                                        placeholder="Enter city"
                                                        value={chequeAddress.city}
                                                        onChange={(e) => {
                                                            setChequeAddress({
                                                                ...chequeAddress,
                                                                city: e.target.value
                                                            }); if (chequeErrors.city) {
                                                                setChequeErrors(prev => ({
                                                                    ...prev,
                                                                    city: ""
                                                                }));
                                                            }
                                                        }}

                                                    />
                                                    {chequeErrors.city && (
                                                        <div className="error-details">{chequeErrors.city}</div>
                                                    )}
                                                </div>
                                                <div className="req-status-field_RD">
                                                    <label>State <span className="asterisk-req_RD"><FaAsterisk /></span></label>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Enter state" value={chequeAddress.state}
                                                        onChange={(e) => {
                                                            setChequeAddress({
                                                                ...chequeAddress,
                                                                state: e.target.value
                                                            });

                                                            if (chequeErrors.state) {
                                                                setChequeErrors(prev => ({
                                                                    ...prev,
                                                                    state: ""
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                    {chequeErrors.state && (
                                                        <div className="error-details">{chequeErrors.state}</div>
                                                    )}
                                                </div>
                                                <div className="req-status-field_RD">
                                                    <label>Zip <span className="asterisk-req_RD"><FaAsterisk /></span></label>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Enter zip"
                                                        value={chequeAddress.zip}
                                                        onChange={(e) => {
                                                            setChequeAddress({
                                                                ...chequeAddress,
                                                                zip: e.target.value
                                                            });

                                                            if (chequeErrors.zip) {
                                                                setChequeErrors(prev => ({
                                                                    ...prev,
                                                                    zip: ""
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                    {chequeErrors.zip && (
                                                        <div className="error-details">{chequeErrors.zip}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="submit-btn-container_RD">
                                            <button type="submit" className="req-status-field-btn_RD">Generate Cheque</button>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* ── View Cheque Modal ── */}
            {showViewChequeModal && (
                <div className="notes-status-overlay_RD">
                    <div className="view-cheque-modal_RD">
                        <div className="notes-status-header_RD">
                            <span className="view-cheque-header_RD">Cheque : ({viewChequeRequestId})</span>
                            <MdCancel size={24} className="closeAddForm_RD"
                                onClick={() => { setShowViewChequeModal(false); setChequePdfUrl(""); }} />
                        </div>
                        <div className="view-cheque-body_RD">
                            <iframe src={chequePdfUrl} title="Cheque PDF" className="cheque-pdf-viewer_RD" />
                        </div>
                    </div>
                </div>
            )}

            <CallRecordingPlayerModal
                isOpen={modalOpen}
                onClose={() => {

                    // stop audio
                    if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.currentTime = 0;
                        audioRef.current.src = "";
                    }

                    // reset states
                    setIsPlaying(false);
                    setPlayingId(null);
                    setAudioUrl(null);

                    // close modal
                    setModalOpen(false);
                }}
                audioRef={audioRef}
                audioUrl={audioUrl}
                callItem={modalItem}
            />

            <DialModal
                isOpen={dialOpen}
                onClose={() => setDialOpen(false)}
                requestID={dialRequestId}
                agencyPhoneNumber={agencyPhoneNumber}
                agencyName={record.agencyName}
                fetchHistory={fetchCallHistory}
                refresh={refreshPage}
            />

        </div>
    );
};

export default TicketDetails;
